import {
  user,
  documentDuplicate,
  key,
  archiveBox,
  heart,
  shoppingCart,
  squaresPlus,
  clipboardDocumentList,
  archiveBoxXMark,
  bellAlert,
  devicePhoneMobile,
  envelope,
  forward,
  arrowsRightLeft,
  photo,
} from "solid-heroicons/outline";

import { PERMISSION, type Permission } from "~/services/roma-api/account/types";

// export type AccountNavItem = {
//   label: string;
//   href: string;
//   icon: IconPath;
//   permission: Permission | null;
//   new?: boolean;
// };

export type AccountNavItem = {
  label: string;
  icon: IconPath;
  permission: PERMISSION | null;
  new?: boolean;
} & ({ href: string } | { onSelect: () => void });

export const accountNav: AccountNavItem[] = [
  {
    label: "My Profile",
    href: "/account/profile",
    icon: user,
    permission: PERMISSION.VIEWPROFILE,
  },
  {
    label: "Change Password",
    href: "/account/password",
    icon: key,
    permission: PERMISSION.RESETPASSWORD,
  },
  {
    label: "Stock Notifications",
    href: "/account/stock-notifications",
    icon: bellAlert,
    permission: null,
    new: true,
  },
  {
    label: "Contact Emails",
    href: "/account/notifications",
    icon: envelope,
    permission: null,
  },
  {
    label: "SMS Mobile Service",
    href: "/account/mobile",
    icon: devicePhoneMobile,
    permission: null,
    new: true,
  },
  {
    label: "Open Orders & History",
    href: "/account/history",
    icon: archiveBox,
    permission: PERMISSION.VIEWPURCHASEHISTORY,
  },
  {
    label: "Documents",
    href: "/account/documents",
    icon: documentDuplicate,
    permission: PERMISSION.ACCESSDOCS,
  },
  {
    label: "Favorites",
    href: "/account/favorites",
    icon: heart,
    permission: null,
  },
];

export const shoppingNav: AccountNavItem[] = [
  {
    label: "Order",
    href: "/order",
    icon: shoppingCart,
    permission: PERMISSION.PLACEORDER,
  },
  {
    label: "Express Order",
    href: "/order/express",
    icon: forward,
    permission: PERMISSION.PLACEORDER,
  },
  {
    label: "Art Fulfillment",
    href: "/order/art-fulfillment",
    icon: photo,
    permission: PERMISSION.PLACEORDER,
    new: true,
  },
  {
    label: "Corner Sample Shop",
    href: "/shop?samples=true",
    icon: squaresPlus,
    permission: PERMISSION.PLACEORDER,
  },
  {
    label: "Returns & Exchanges",
    href: "/support/returns-request",
    icon: arrowsRightLeft,
    permission: PERMISSION.RETURNSFORM,
  },
];

export const adminNav: AccountNavItem[] = [
  {
    label: "Order Approval",
    href: "/account/admin/orders",
    icon: clipboardDocumentList,
    permission: PERMISSION.APPROVESAMPLES,
  },
  {
    label: "BPS Order Approval",
    href: "/account/admin/orders",
    icon: clipboardDocumentList,
    permission: PERMISSION.BPSAPPROVEORDERS,
  },
  {
    label: "Product Archive",
    href: "/shop?archive=true",
    icon: archiveBoxXMark,
    permission: PERMISSION.VIEWARCHIVE,
  },
];

export const filterByPermissions = (
  list: AccountNavItem[],
  permissions: Permission[]
) => {
  if (!list || !permissions) return [];
  return list.filter(
    (item) => item.permission === null || permissions.includes(item.permission)
  );
};
